import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export default function ThumbUpAltOutlined(props:any) {
  return (
    <SvgIcon {...props}>
      <path d="M2 21h4V9H2v12zM22 10c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L13.17 2 6.59 8.59C6.22 8.95 6 9.45 6 10v9c0 1.1.9 2 2 2h8c.66 0 1.23-.33 1.59-.84L22 12.5V10z" />
    </SvgIcon>
  )
}
